import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

export interface UseSetLocationsExistenceProps {
  isActive: boolean;
}

export const useSetLocationsExistence = ({
  isActive,
}: UseSetLocationsExistenceProps): void => {
  const { getValues, setValue, formState } =
    useFormContext<IMealCreditFormFields>();
  const {
    dirtyFields: { locationsExistence: isLocationsExistenceDirty },
    errors: { locations: locationsError },
  } = formState;

  useEffect(() => {
    if (!isActive && (locationsError || isLocationsExistenceDirty)) {
      updateLocationExistence();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive, locationsError, isLocationsExistenceDirty]);

  function updateLocationExistence() {
    const locationsExistence = getValues('locationsExistence');
    const locations = getValues('locations') || {};

    if (
      locationsExistence === 'hasLocation' &&
      Object.keys(locations).length === 0
    ) {
      setValue('locationsExistence', 'hasNoLocation');
    }
  }
};
